
export default [
  {
    path: '/templateManagement',
    name: 'templateManagement',
    meta: { title: '电子面单' },
    component: () => import('@/views/electronicTemplate/electronicWayBill')
  } 
]
